import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import { AuthProvider, useAuth } from "./AuthContext";
import { Toaster } from "sonner";
import Login from "./pages/Login";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import Customers from "./pages/Customers";
import Products from "./pages/Products";
import Orders from "./pages/Orders";
import Quotations from "./pages/Quotations";
import Invoices from "./pages/Invoices";
import InvoiceDetail from "./pages/InvoiceDetail";
import Reports from "./pages/Reports";
import Users from "./pages/Users";
import Reorders from "./pages/Reorders";
import Tasks from "./pages/Tasks";
import PaymentCollection from "./pages/PaymentCollection";
import ImportData from "./pages/ImportData";
import FollowUps from "./pages/FollowUps";
import ProfitReport from "./pages/ProfitReport";
import PricingCalculator from "./pages/PricingCalculator";
import Variants from "./pages/Variants";
import ChurnAlerts from "./pages/ChurnAlerts";
import RawCosts from "./pages/RawCosts";
import AIInstructions from "./pages/AIInstructions";
import VisitPlanner from "./pages/VisitPlanner";
import PendingOrders from "./pages/PendingOrders";
import DeliveryRoute from "./pages/DeliveryRoute";
import PaymentDashboard from "./pages/PaymentDashboard";
import Incentives from "./pages/Incentives";

function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="customers" element={<Customers />} />
            <Route path="products" element={<Products />} />
            <Route path="orders" element={<Orders />} />
            <Route path="quotations" element={<Quotations />} />
            <Route path="invoices" element={<Invoices />} />
            <Route path="invoices/:id" element={<InvoiceDetail />} />
            <Route path="reorders" element={<Reorders />} />
            <Route path="followups" element={<FollowUps />} />
            <Route path="tasks" element={<Tasks />} />
            <Route path="payment-collection" element={<PaymentCollection />} />
            <Route path="pricing" element={<PricingCalculator />} />
            <Route path="visits" element={<VisitPlanner />} />
            <Route path="pending-orders" element={<PendingOrders />} />
            <Route path="delivery-route" element={<DeliveryRoute />} />
            <Route path="payment-dashboard" element={<PaymentDashboard />} />
            <Route path="incentives" element={<Incentives />} />
            <Route path="variants" element={<Variants />} />
            <Route path="churn" element={<ChurnAlerts />} />
            <Route path="reports" element={<Reports />} />
            <Route
              path="raw-costs"
              element={
                <ProtectedRoute adminOnly>
                  <RawCosts />
                </ProtectedRoute>
              }
            />
            <Route
              path="ai-instructions"
              element={
                <ProtectedRoute adminOnly>
                  <AIInstructions />
                </ProtectedRoute>
              }
            />
            <Route
              path="import"
              element={
                <ProtectedRoute adminOnly>
                  <ImportData />
                </ProtectedRoute>
              }
            />
            <Route
              path="profit"
              element={
                <ProtectedRoute adminOnly>
                  <ProfitReport />
                </ProtectedRoute>
              }
            />
            <Route
              path="users"
              element={
                <ProtectedRoute adminOnly>
                  <Users />
                </ProtectedRoute>
              }
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
